export default "__VITE_ASSET__805b7b97__"